export var Symbols  = 'symbol';
export var Discrete = 'discrete';
export var Gradient = 'gradient';



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-encode/src/legend-types.js
// module id = 314
// module chunks = 0